import { TableWrapper, TableHead, TableBody, TableRow, PaginationContainer, ControlPanel } from "./components";
import style from "./TableCost.module.scss";

export function TableCost() {
    return (
        <div className={style.tableManager}>
            <ControlPanel />
            <div className={style.tableContainer}>
                <div data-scrollable className={style.scrollBox}>
                    <TableWrapper>
                        <TableHead />
                        <TableBody>
                            {(data) => (
                                <TableRow key={data.id} data={data} />
                            )}
                        </TableBody>
                    </TableWrapper>
                </div>
            </div>
            <PaginationContainer /> 
        </div>
    )
}